import { injectable } from 'inversify';
import { isBefore, parseISO, startOfDay } from 'date-fns';

import { FormatService } from '@vk-hr-tek/core/format';

import {
  VacationAdminCompany,
  VacationCustomTypeItem,
} from '@app/gen/vacations';
import { UnitNode } from '@app/gen/settings';

import { UnitNodeLabeled } from '../../types';

@injectable()
export class VacationsMapper {
  constructor(private readonly format: FormatService) {}

  processAvailableAddingEmployees(
    availableAddingEmployees: boolean,
    employeeDeadline: string,
  ) {
    const deadlinePassed = isBefore(
      startOfDay(parseISO(employeeDeadline)),
      startOfDay(new Date()),
    );

    return availableAddingEmployees && !deadlinePassed;
  }

  processScheduleName(year: number | string, name?: string) {
    return name || `График отпусков ${year} год`;
  }

  processVacationAdminCompanies(companies: VacationAdminCompany[]) {
    return companies.map(
      ({
        can_create_company_type_schedule,
        id,
        name,
        unit_planned_vacations_percent_enabled,
      }) => ({
        disabled: !can_create_company_type_schedule,
        id,
        label: name,
        value: id,
        thresholdPercentEnabled: unit_planned_vacations_percent_enabled,
      }),
    );
  }

  processVacationCustomTypes(customTypes: VacationCustomTypeItem[]) {
    return customTypes
      .filter(({ custom_type }) => !!custom_type)
      .map(({ custom_type, has_vacation_schedule }) => ({
        customType: custom_type,
        hasVacationSchedule: has_vacation_schedule,
      }));
  }

  processUnitsTree(node: UnitNode): UnitNodeLabeled {
    return {
      id: node.id,
      label: node.name,
      count: node.employee_count || 0,
      hasChildrenToLoad: node.is_parent,
      hasSeparateAbove: node.has_separate_above,
      isSeparate: node.is_separate,
      disabled: node.has_vacation_schedule,
      children: node.children
        ? node.children
            .map((child) => this.processUnitsTree(child))
            .filter((unit) => unit)
        : [],
    };
  }
}
